import React, { useEffect, useReducer, useState } from "react";
import RegistorMain from "./RegistorComponents/RegistorMain";
// import useRegister from '../../Hooks/Registration/useRegister';
import OtpComponent from "./RegistorComponents/OtpComponent";
import FirstDetails from "./RegistorComponents/FirstDetails";
import CvStep from "./RegistorComponents/CvStep";
import useCreateProfile from "../../Hooks/Registration/useCreateProfile";
import Designation from "./RegistorComponents/Designation";
import Profile from "./RegistorComponents/Profile";
import arrowIcon from "../../Assets/arrow_back.svg";
import {
  AuthStepsHeading,
  AuthStepsParagraph,
} from "../../constents/components";
import Illustrations from "./Illustrations";
import logo from "../../Assets/logo.png";
import registrationMain from "../../Assets/Illustrations/Registration.svg";
import optPage from "../../Assets/forgotPassword/otpPage.svg";
import thired from "../../Assets/Illustrations/thired.svg";
import fourth from "../../Assets/Illustrations/fourth.svg";
import fifth from "../../Assets/Illustrations/fifth.svg";
import six from "../../Assets/Illustrations/six.svg";
import seven from "../../Assets/Illustrations/seven.svg";
import PopUp from "./RegistorComponents/PopUp";
import { Navigate, useSearchParams } from "react-router-dom";
import {
  updateCurrentRegistrationStep,
  updateRegistrationStates,
} from "../../Store/Slices/registrationStates";
import { useDispatch, useSelector } from "react-redux";

const BackButton = ({ setState }) => {
  return (
    <div className=" flex justify-start">
      <img
        onClick={() => setState((pre) => pre - 1)}
        src={arrowIcon}
        className=" cursor-pointer"
        alt="backButton"
      />
    </div>
  );
};

const ProgressBar = ({ width, number }) => {
  return (
    <div className=" w-full">
      <div className="mt-6 h-1 w-full bg-[#f0f0f0] relative overflow-hidden rounded-sm">
        <span
          className=" absolute top-0 left-0 h-full bg-primary-color-900"
          style={{ width: width + "%" }}
        ></span>
      </div>
      <div className="mt-1 flex justify-between">
        <span className=" font-semibold">Step Completed</span>
        <span className=" font-semibold">{`${number}/04`}</span>
      </div>
    </div>
  );
};

const Register = () => {
  const [params, setParams] = useSearchParams();

  // useEffect(()=>{ console.log('HI')});
  // const [currentStep, setCurrentStep] = useState(params?.get('steps') ?? 'onboarding_one');
  const currentStep = params?.get("steps");

  // const sendToNextStep = () => setCurrentStep(pre => pre + 1);

  // const [loading, error, isUserCreated, registerFunction] = useRegister();
  const [updateDetailsLoading, updateDetailsError, someState, proofileUpdater] =
    useCreateProfile({
      onSucess: () => setParams({ steps: "onboarding_eight" }),
    });

  const UPDATE_PROFILE_IMAGE = "UPDATE_PROFILE_IMAGE";
  const UPDATE_BASIC_DETAILS = "UPDATE_BASIC_DETAILS";
  const UPDATE_CV_LINKEDIN = "UPDATE_CV_LINKEDIN";
  const UPDATE_INTEREST = "UPDATE_INTEREST";
  const UPDATE_EMAIL = "UPDATE_EMAIL";
  const UPDATE_MOBILE = "UPDATE_MOBILE";
  const UPDATE_PASSWORD = "UPDATE_PASSWORD";
  const UPDATE_FIRST_NAME = "UPDATE_FIRST_NAME";
  const UPDATE_LAST_NAME = "UPDATE_LAST_NAME";
  const UPDATE_GENDER = "UPDATE_GENDER";
  const UPDATE_DESIGNATION = "UPDATE_DESIGNATION";
  const UPDATE_STATE = "UPDATE_STATE";
  const UPDATE_COUNTRY = "UPDATE_COUNTRY";
  const UPDATE_PROFILE = "UPDATE_PROFILE";
  const UPDATE_CV = "UPDATE_CV";
  const UPDATE_LINKEDIN = "UPDATE_LINKEDIN";
  const UPDATE_CURRENT_CTC = "UPDATE_CURRENT_CTC";
  const UPDATE_EXPECTED_CTC = "UPDATE_EXPECTED_CTC";
  const UPDATE_JOB_INDUSTRY = "UPDATE_JOB_INDUSTRY";
  const UPDATE_CITY = "UPDATE_CITY";
  const UPDATE_EDUCATION = "UPDATE_EDUCATION";
  const UPDATE_YEARS_OF_EXPERIENCE = "UPDATE_YEARS_OF_EXPERIENCE";
  // const initials = {
  //     email: '',
  //     password: '',
  //     firstName: '',
  //     lastName: '',
  //     gender: '',
  //     designation: '',
  //     state: '',
  //     country: '',
  //     linkedin: '',
  //     interest: [],
  //     profile: '',
  //     cv: {},
  //     currentCtc: 0,
  //     expectedCtc: 0,
  //     jobIndustry: '',
  // }

  // const reducer = (state, action) => {
  //     switch (action.type) {
  //         case UPDATE_PROFILE_IMAGE: {
  //             return { ...state, profile: action.payload };
  //         };
  //             break;
  //         case UPDATE_BASIC_DETAILS: {
  //             return { ...state, ...action.payload };
  //         };
  //             break;
  //         case UPDATE_CV_LINKEDIN: {
  //             return { ...state, ...action.payload };
  //         };
  //             break;
  //         case UPDATE_INTEREST: {
  //             return { ...state, interest: action.payload };
  //         };
  //         case UPDATE_PASSWORD: {
  //             return { ...state, password: action.payload };
  //         };
  //         case UPDATE_EMAIL: {
  //             return { ...state, email: action.payload };
  //         };
  //         case UPDATE_FIRST_NAME: {
  //             return { ...state, firstName: action.payload };
  //         };
  //         case UPDATE_LAST_NAME: {
  //             return { ...state, lastName: action.payload };
  //         };
  //         case UPDATE_GENDER: {
  //             return { ...state, gender: action.payload };
  //         };
  //         case UPDATE_DESIGNATION: {
  //             return { ...state, designation: action.payload };
  //         };
  //         case UPDATE_STATE: {
  //             return { ...state, state: action.payload };
  //         };
  //         case UPDATE_COUNTRY: {
  //             return { ...state, country: action.payload };
  //         };
  //         case UPDATE_CV: {
  //             return { ...state, cv: action.payload };
  //         };
  //         case UPDATE_LINKEDIN: {
  //             return { ...state, linkedin: action.payload };
  //         };
  //         case UPDATE_CURRENT_CTC: {
  //             return { ...state, currentCtc: action.payload };
  //         };
  //         case UPDATE_EXPECTED_CTC: {
  //             return { ...state, expectedCtc: action.payload };
  //         };
  //         case UPDATE_JOB_INDUSTRY: {
  //             return { ...state, jobIndustry: action.payload };
  //         };
  //             break;
  //         default: { return { ...state } };
  //     }
  // };

  const dispatch = useDispatch();
  const updateMobile = (value) =>
    dispatch(
      updateRegistrationStates({
        type: UPDATE_MOBILE,
        payload: value,
      }),
    );
  const updateEmail = (value) =>
    dispatch(updateRegistrationStates({ type: UPDATE_EMAIL, payload: value }));
  const updatePassword = (value) =>
    dispatch(
      updateRegistrationStates({ type: UPDATE_PASSWORD, payload: value }),
    );

  const updateFirstName = (value) =>
    dispatch(
      updateRegistrationStates({ type: UPDATE_FIRST_NAME, payload: value }),
    );
  const updateLastName = (value) =>
    dispatch(
      updateRegistrationStates({ type: UPDATE_LAST_NAME, payload: value }),
    );
  const updateGender = (value) =>
    dispatch(updateRegistrationStates({ type: UPDATE_GENDER, payload: value }));
  const updateState = (value) =>
    dispatch(updateRegistrationStates({ type: UPDATE_STATE, payload: value }));
  const updateCountry = (value) =>
    dispatch(
      updateRegistrationStates({ type: UPDATE_COUNTRY, payload: value }),
    );

  const updateCity = (value) =>
    dispatch(updateRegistrationStates({ type: UPDATE_CITY, payload: value }));
  const updateEducation = (value) =>
    dispatch(
      updateRegistrationStates({ type: UPDATE_EDUCATION, payload: value }),
    );

  const updateYearsOfExperience = (value) => {
    dispatch(
      updateRegistrationStates({
        type: UPDATE_YEARS_OF_EXPERIENCE,
        payload: Number(value),
      }),
    );
  };

  const updateInterest = (value) =>
    dispatch(
      updateRegistrationStates({ type: UPDATE_INTEREST, payload: value }),
    );
  const updateJobIndustry = (value) =>
    dispatch(
      updateRegistrationStates({ type: UPDATE_JOB_INDUSTRY, payload: value }),
    );

  const updateDesignation = (value) =>
    dispatch(
      updateRegistrationStates({ type: UPDATE_DESIGNATION, payload: value }),
    );
  const updateCurrentCTC = (value) =>
    dispatch(
      updateRegistrationStates({
        type: UPDATE_CURRENT_CTC,
        payload: parseInt(value),
      }),
    );
  const updateExpectedCTC = (value) =>
    dispatch(
      updateRegistrationStates({
        type: UPDATE_EXPECTED_CTC,
        payload: parseInt(value),
      }),
    );

  const updateProfileImage = (url) =>
    dispatch(
      updateRegistrationStates({ type: UPDATE_PROFILE_IMAGE, payload: url }),
    );

  const updateCv = (value) =>
    dispatch(updateRegistrationStates({ type: UPDATE_CV, payload: value }));
  const updateLinkedin = (value) =>
    dispatch(
      updateRegistrationStates({ type: UPDATE_LINKEDIN, payload: value }),
    );
  const uploadProfileDetails = () => proofileUpdater(state);

  const state = useSelector((store) => store?.registrationStates);

  // useEffect(() => {
  //     dispatch(updateCurrentRegistrationStep(currentStep));
  // }, [window.location.search]);

  if (!params?.get("steps")) {
    return <Navigate to={"/auth/register?steps=onboarding_one"} />;
    // setParams({ steps: 'onboarding_one' })
  }

  const list = {
    onboarding_one: (
      <RegistorMain
        updateEmail={updateEmail}
        updatePassword={updatePassword}
        details={state}
        sendToNextStep={() => {
          dispatch(updateCurrentRegistrationStep("onboarding_two"));
          setParams({ steps: "onboarding_two" });
        }}
      />
    ),

    onboarding_two: (
      <div className=" flex items-center flex-col min-h-[50vh]">
        <AuthStepsHeading text="Enter OTP*" />
        <OtpComponent
          details={state}
          sendToNextStep={() => {
            dispatch(updateCurrentRegistrationStep("onboarding_three"));
            setParams({ steps: "onboarding_three" });
          }}
        />
      </div>
    ),

    onboarding_three: (
      <div className="flex items-center flex-col min-h-[50vh]">
        <AuthStepsHeading text="Create your workspace" />
        <AuthStepsParagraph text="Customize your workspace for a tailored job experience." />
        <ProgressBar width={25} number={"01"} />
        <FirstDetails
          details={state}
          sendToNextStep={() => {
            dispatch(updateCurrentRegistrationStep("onboarding_four"));
            setParams({ steps: "onboarding_four" });
          }}
          updateFunctions={{
            updateFirstName,
            updateLastName,
            updateGender,
            updateState,
            updateCity,
            updateCountry,
            updateMobile
          }}
        />
      </div>
    ),

    onboarding_four: (
      <div className="flex items-center flex-col min-h-[50vh]">
        <AuthStepsHeading text="Create your workspace" />
        <AuthStepsParagraph text="Customize your workspace for a tailored job experience." />
        <ProgressBar width={50} number={"02"} />
        <Designation
          details={state}
          sendToNextStep={() => {
            dispatch(updateCurrentRegistrationStep("onboarding_five"));
            setParams({ steps: "onboarding_five" });
          }}
          updateFunctions={{
            updateEducation,
            updateDesignation,
            updateYearsOfExperience,
            updateExpectedCTC,
            updateCurrentCTC,
          }}
        />
      </div>
    ),

    onboarding_five: (
      <div className="flex items-center flex-col min-h-[50vh]">
        <AuthStepsHeading text="Create your workspace" />
        <AuthStepsParagraph text="" />
        <ProgressBar width={75} number={"03"} />
        <Profile
          details={state}
          sendToNextStep={() => {
            dispatch(updateCurrentRegistrationStep("onboarding_six"));
            setParams({ steps: "onboarding_six" });
          }}
          updateFunctions={{ updateProfileImage }}
        />
      </div>
    ),
    onboarding_six: (
      <div className="flex items-center flex-col min-h-[50vh]">
        <AuthStepsHeading text="Create your workspace" />
        <AuthStepsParagraph text="Customize your workspace for a tailored job experience." />
        <ProgressBar width={100} number={"04"} />
        <CvStep
          details={state}
          sendToNextStep={() =>
            uploadProfileDetails().then(() => {
              dispatch(updateCurrentRegistrationStep("onboarding_seven"));
              setParams({ steps: "onboarding_seven" });
            })
          }
          updateFunctions={{
            updateCv,
            updateLinkedin,
            updateInterest,
            updateJobIndustry,
          }}
        />
      </div>
    ),
    onboarding_seven: (
      <div className="flex items-center flex-col min-h-[50vh]">
        <PopUp />
        <AuthStepsHeading text="Create your workspace" />
        <AuthStepsParagraph text="Customize your workspace for a tailored job experience." />
        <ProgressBar width={100} number={"04"} />
        <CvStep
          details={state}
          sendToNextStep={uploadProfileDetails}
          updateFunctions={{
            updateCv,
            updateLinkedin,
            updateInterest,
            updateJobIndustry,
          }}
        />
      </div>
    ),
  };

  const illustrationList = {
    onboarding_one: {
      imgIcon: registrationMain,
      mainHeading: "Recruitment is Time-Consuming, but Not with Zepcruit",
      subHeading: "",
      bottomText: "",
    },
    onboarding_two: {
      imgIcon: optPage,
      mainHeading: "Recruitment is Time-Consuming, but Not with Zepcruit",
      subHeading: "",
      bottomText: "",
    },
    onboarding_three: {
      imgIcon: thired,
      mainHeading: "Skip the Job Board Drama",
      subHeading: "(Because Algorithms Are Smarter Than Your Ex)",
      bottomText: "",
    },
    onboarding_four: {
      imgIcon: fourth,
      mainHeading: "Instant Career Glow-Up",
      subHeading:
        "Why wait years to stand out? With Zepcruit’s smart tools, you’ll have recruiters sliding into your inbox in no time.",
      bottomText: "",
    },
    onboarding_five: {
      imgIcon: fifth,
      mainHeading: " Focus on Today, We’ll Scroll for You",
      subHeading:
        "Stay present—let Zepcruit handle the job search while you focus on today’s success.",
      bottomText: "",
    },
    onboarding_six: {
      imgIcon: six,
      mainHeading: "Find Work Without Hassle",
      subHeading:
        "Forget endless scrolling—Zepcruit simplifies your job search, hassle-free and stress-free.",
      bottomText: "",
    },
    onboarding_seven: {
      imgIcon: seven,
      mainHeading: "Unlimited job recommendations,",
      subHeading: "Zero Cost (Your Wallet Will Approve)",
      bottomText: "",
    },
    onboarding_eight: {
      imgIcon: seven,
      mainHeading: "Unlimited job recommendations,",
      subHeading: "Zero Cost (Your Wallet Will Approve)",
      bottomText: "",
    },
  };

  return (
    <div className=" flex flex-col lg:flex-row min-h-screen">
      <Illustrations
        imgIcon={illustrationList?.[currentStep]?.imgIcon}
        mainHeading={illustrationList?.[currentStep]?.mainHeading}
        subHeading={illustrationList?.[currentStep]?.subHeading}
        bottomText={illustrationList?.[currentStep]?.bottomText}
      >
        {illustrationList?.[currentStep]?.child}
      </Illustrations>

      <div className="flex flex-col flex-1 p-4  bg-white items-center lg:pt-16 ">
        <div className="flex items-center flex-col">
          <img
            className=" w-44 hidden md:block "
            src={logo}
            alt={"logo-Icon"}
          />
          {list[currentStep]}
        </div>
      </div>
    </div>
  );
};
export default Register;
